/* ------------------------------------------------------------------
   QuickstartPage.js — the dashboard landing hub.
   Where users arrive on login: pick what to create and jump to the
   existing page. Built as a card grid so we can add more actions later.
------------------------------------------------------------------ */
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Images, Magic, ArrowRight } from 'react-bootstrap-icons';
import { UserContext } from '../../context/UserContext';

const ACTIONS = [
  {
    key: 'single',
    to: '/dashboard/post',
    Icon: Images,
    title: 'Create a single post',
    desc: 'Write a post, add media, pick accounts, and publish or schedule it.',
    accent: '#2563eb', bg: '#eff6ff',
  },
  {
    key: 'bulk',
    to: '/dashboard/studio/bulk',
    Icon: Magic,
    title: 'Bulk AI Post Creator',
    desc: 'Answer a few questions and generate a batch of on-brand posts — captions and photos — ready to schedule.',
    accent: '#4f46e5', bg: '#eef2ff', badge: 'AI',
  },
];

export default function QuickstartPage() {
  const navigate = useNavigate();
  const { user } = useContext(UserContext) || {};
  const name = (user?.name || user?.firstName || '').trim().split(' ')[0];

  return (
    <div style={{ maxWidth: 880, margin: '0 auto' }}>
      <div style={{ marginBottom: 22 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#111827', margin: '0 0 4px' }}>
          {name ? `Welcome back, ${name}` : 'Welcome'} 👋
        </h1>
        <p style={{ color: '#6b7280', fontSize: 15, margin: 0 }}>What would you like to create today?</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}>
        {ACTIONS.map(a => (
          <button
            key={a.key}
            onClick={() => navigate(a.to)}
            style={{
              textAlign: 'left', cursor: 'pointer', background: '#fff',
              border: '1px solid #e5e7eb', borderRadius: 14, padding: 22,
              display: 'flex', flexDirection: 'column', gap: 12, transition: 'box-shadow .15s, transform .15s, border-color .15s',
            }}
            onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = a.accent; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.transform = 'none'; }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ width: 46, height: 46, borderRadius: 12, background: a.bg, color: a.accent, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <a.Icon size={22} />
              </div>
              {a.badge && <span style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.04em', color: a.accent, background: a.bg, padding: '3px 9px', borderRadius: 99 }}>{a.badge}</span>}
            </div>
            <div>
              <div style={{ fontSize: 17, fontWeight: 700, color: '#111827', marginBottom: 4 }}>{a.title}</div>
              <div style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.5 }}>{a.desc}</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: a.accent, fontWeight: 700, fontSize: 14, marginTop: 'auto' }}>
              Get started <ArrowRight size={15} />
            </div>
          </button>
        ))}
      </div>

      <p style={{ color: '#9ca3af', fontSize: 13, marginTop: 22 }}>
        More quick actions are coming here. You can always use the sidebar to jump anywhere.
      </p>
    </div>
  );
}
